import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import formulaMark from "../../../assets/brand/logo.png";

export function AuthLayout({ eyebrow, title, subtitle, tagline, children }) {
  useEffect(() => { document.title = `${title} | Formula Soccer`; }, [title]);
  return (
    <div className="auth-shell">
      <aside className="auth-shell-media">
        <Link to="/" className="auth-shell-media-brand" aria-label="Formula Soccer home">
          <img src={formulaMark} alt="Formula Soccer Center" />
        </Link>
        <div className="auth-shell-media-copy">
          <h2>{tagline?.title || "Player development, measured."}</h2>
          <p>{tagline?.body || "Track assessments, book training sessions, and manage memberships all in one place."}</p>
        </div>
        <p className="auth-shell-media-foot">Formula Soccer Center</p>
      </aside>

      <div className="auth-shell-panel">
        <div className="auth-card">
          <Link to="/" className="auth-back-link">
            <ArrowLeft size={14} /> Back to site
          </Link>
          {eyebrow && <p className="auth-eyebrow">{eyebrow}</p>}
          <h1 className="auth-title">{title}</h1>
          {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
